import React, { useEffect } from 'react';

import { GlobalSettingsProvider } from 'context/GlobalSettingsContext';
import { ContentstackProvider } from 'context/contenstack';
import { LocaleProvider } from 'context/locale';

import { useVisitorStatus } from 'hooks/useVisitorStatus';

import AnalyticsService from 'services/analyticsService';

const Analytics = ({ pathname, pageContext }) => {
  useEffect(() => {
    AnalyticsService.trackPageDataLoaded({
      pageType: pageContext?.page_components?.page_type,
      campaignPageType: pageContext?.page_components?.campaign_type,
    });
  }, [pathname]);

  return null;
};

const VisitorStatusHandler = () => {
  useVisitorStatus();
  return null;
};

export const wrapPageElement = ({ element, props }) => {
  const { localisation, availableLocalisations, page_components, ab_test_configuration, globalSettings } =
    props.pageContext;

  return (
    <LocaleProvider localisation={localisation} availableLocalisations={availableLocalisations}>
      <VisitorStatusHandler />
      <ContentstackProvider
        key={page_components?.uid} // Recreate provider on every page change
        pageData={page_components}
        personalizeData={props.pageContext.personalizedData}
        abTestConfiguration={ab_test_configuration}
      >
        <GlobalSettingsProvider settings={globalSettings}>
          <Analytics pathname={props.location.pathname} pageContext={props.pageContext} />
          {element}
        </GlobalSettingsProvider>
      </ContentstackProvider>
    </LocaleProvider>
  );
};
